export interface IPDFComponentStatus {
  pageSizePixelList: Record<string, { x: string; y: string }>;
  activeWidth: string;
  is_generating: boolean;
  options?: {
    porientation: string;
    scale: number;
    paperSize: string;
    forceProxy?: boolean;
  };
}

export const pdfDefaultValues: IPDFComponentStatus = {
  activeWidth: '',
  is_generating: false,
  pageSizePixelList: {
    A3: { x: '842', y: '831' },
    A4: { x: '595', y: '842' },
    A5: { x: '420', y: '595' },
  },
  options: { paperSize: 'A4', porientation: 'landscape', scale: 0.5 },
};

export function resolvePdfActiveWidth(values: IPDFComponentStatus): string {
  if (!values?.is_generating) {
    return 'auto';
  }
  try {
    const paperSize = values.options?.paperSize?.toLowerCase();
    const key = Object.keys(values.pageSizePixelList ?? {}).find(k => k.toLowerCase() === paperSize);
    if (!key) {
      return '';
    }
    return values.options?.porientation === 'landscape' ? values.pageSizePixelList[key]?.x : values.pageSizePixelList[key]?.y;
  } catch {
    return '';
  }
}

export function mergePdfGeneratorState(data: IPDFComponentStatus, deviceHints?: { isMobile?: boolean; isTablet?: boolean }): IPDFComponentStatus {
  const forceProxy = !!(deviceHints?.isMobile || deviceHints?.isTablet);
  const activeWidth = data.is_generating ? resolvePdfActiveWidth(data) : '';
  return {
    ...data,
    activeWidth,
    options: { ...data.options, forceProxy },
  };
}
